// extracted by mini-css-extract-plugin
export default {"header":"header--YGWap","n12-logo":"n12-logo--LkHQl","n12Logo":"n12-logo--LkHQl","centered-logo":"centered-logo--p2aun","centeredLogo":"centered-logo--p2aun"};